class ClientContextStore {
  /**
   * The internal `Map` to store context data.
   * @private
   * @type {Map<string, any>}
   */
  #data;

  constructor() {
    this.#data = new Map();
  }

  /**
   * Retrieves a value from the context based on the provided key.
   * @param {string} key The key of the value to retrieve.
   * @returns {any | undefined} The value associated with the key, or `undefined` if the key does not exist.
   */
  get(key) {
    return this.#data.get(key);
  }

  /**
   * Sets a key-value pair in the context.
   * @param {string} key The key to set.
   * @param {any} value The value to associate with the key.
   */
  set(key, value) {
    this.#data.set(key, value);
  }
}

/**
 * A class representing a client context in a client-side environment.
 */
export class ClientContext {
  /**
   * The internal `Store` for context data.
   * @private
   * @type {ClientContextStore}
   */
  #store;

  constructor() {
    this.#store = new ClientContextStore();
  }

  /**
   * Returns context store.
   * @returns {ClientContextStore}
   */
  getStore() {
    return this.#store;
  }

  /**
   * This method is intended for asynchronous context management in Node.js.
   * It throws an error in the client-side context as it's not implemented here.
   * @throws {Error} "Method not implemented."
   */
  // eslint-disable-next-line class-methods-use-this
  run() {
    throw new Error('Method not implemented.');
  }
}
